import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { PersonTermsAcceptance } from '../../../model/person';
import { TermsAcceptanceActionTypes } from './types';

export const termsAcceptanceRequest = () => action(TermsAcceptanceActionTypes.TERMS_ACCEPTANCE_REQUEST);
export const termsAcceptanceSuccess = (terms: PersonTermsAcceptance) => action(TermsAcceptanceActionTypes.TERMS_ACCEPTANCE_SUCCESS, terms);
export const termsAcceptanceError = (error: GiroWebappError) => action(TermsAcceptanceActionTypes.TERMS_ACCEPTANCE_ERROR, error);

export const termsAcceptanceResetState = () => action(TermsAcceptanceActionTypes.TERMS_ACCEPTANCE_RESET_STATE);